module.exports = "/images/Tag.svg";